module.exports = __webpack_public_path__ + "img/noContent.8af539dd.png";